<template>
  <div>
    <div class="row row-equal">
      <div class="flex md5">
        <va-card>
          <div class="row">
            <div class="flex md12">
              <va-select
                label="Départements"
                v-model="listDeptSelected"
                :options="departementsOptions"
                searchable
                multiple
              />
            </div>
          </div>
          <div class="row">
            <div class="flex md6">
              <va-checkbox
                label="Inclure infos dernières adhésion"
                v-model="include_adh_infos"
              />
            </div>
            <div class="flex md6">
              <va-checkbox
                label="Sélectionner tous les départements"
                v-model="selectAll"
              />
            </div>

            <div class="flex md6">
              <va-select
                label="Adhésions expirées depuis moins de :"
                v-model="selectDuree"
                textBy="description"
                :options="listeDuree"
              />
            </div>
            <div class="flex md6">
              <va-date-picker
                label="Date maximum d'expiration"
                :disabled="!!selectDuree"
                :config="{ dateFormat: 'd-m-Y' }"
                v-model="date_fin_fr"
              />
            </div>

            <div class="flex md12">
              <va-button
                outline
                color="info"
                @click="exportDepartements()"
              >Export Départements</va-button>
            </div>
          </div>
        </va-card>
      </div>
      <div class="flex md3">
        <va-card>
          <div class="row">
            <div class="flex md12">
              <va-button
                outline
                color="info"
                @click="exportAcota()"
              >Export ACOTA</va-button>
            </div>
          </div>
        </va-card>
      </div>

      <div class="flex md4">
        <va-card>
          <div class="row">
            <div class="flex md6">
              <va-select
                label="Structure"
                v-model="structureSelected"
                textBy="description"
                :options="structuresOptions"
                no-clear
              />
            </div>
            <div class="flex md3">
              <va-button
                outline
                color="info"
                @click="exportStructures()"
              >Export</va-button>
            </div>
          </div>
        </va-card>
      </div>
      <div class="flex md5">
        <va-card>
          <div class="row">
            <div class="flex md12">
              <va-button
                outline
                color="info"
                @click="exportAdherents('all')"
              >Adhérents OPEF historiques</va-button>
            </div>
          </div>
          <div class="row">
            <div class="flex md6">
              <va-button
                outline
                color="info"
                @click="exportAdherents()"
              >Adhérents OPEF au:</va-button>
            </div>
            <div class="flex md6">
              <va-date-picker
                :config="{ dateFormat: 'd-m-Y' }"
                label="Date de valeur"
                v-model="startDateOpef"
              />
            </div>
          </div>
        </va-card>
      </div>
      <div class="flex md5">
        <va-card>
          <div class="row">
            <div class="flex md12">
              <va-button
                outline
                color="info"
                @click="exportNonAdherents()"
              >Export non adhérents</va-button>
            </div>
          </div>

        </va-card>
      </div>
      <div class="flex md5">
        <va-card>
          <div class="row">
            <div class="flex md6">
              <va-button
                outline
                color="info"
                @click="exportYearStatistics()"
              >Export statistiques annuelles</va-button>
            </div>
            <div class="flex md6">
              <va-input
                type="number"
                label="Année"
                v-model="selectedYear"
                :min="2000"
                :max="2100"
              />
            </div>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { launchToast } from "../../services/utils";
import moment from "moment";

export default {
  data() {
    return {
      selectAll: false,
      selectDate: true,
      date_fin_fr: moment().subtract(6, 'month').format("DD-MM-YYYY"),
      include_adh_infos: false,
      selectDuree: "",
      listeDuree: [
        { id: 0, description: "1 mois", duree: 1, type: "month" },
        { id: 1, description: "3 mois", duree: 3, type: "month" },
        { id: 2, description: "6 mois", duree: 6, type: "month" },
        { id: 3, description: "1 an", duree: 1, type: "year" },
        { id: 4, description: "5 ans", duree: 5, type: "year" },
      ],

      departementsOptions: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
        "60",
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "68",
        "69",
        "70",
        "71",
        "72",
        "73",
        "74",
        "75",
        "76",
        "77",
        "78",
        "79",
        "80",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "87",
        "88",
        "89",
        "90",
        "91",
        "92",
        "93",
        "94",
        "95",
        "971",
        "972",
        "973",
        "974",
        "975",
        "976",
        "977",
        "978"
      ],
      listDeptSelected: [],
      startDateOpef: moment().format("DD-MM-YYYY"),
      selectedYear: new Date().getFullYear(),
      structureSelected: {
        id: 1,
        description: "SCAPP"
      },
      structuresOptions: [
        {
          id: 1,
          description: "SCAPP"
        },
        {
          id: 2,
          description: "OPAM-B"
        },
        {
          id: 3,
          description: "AGROMER"
        },
        {
          id: 4,
          description: "Languedoc-Roussillon"
        },
        {
          id: 5,
          description: "Vendée"
        },
        {
          id: 6,
          description: "S.D.E.P."
        }
      ]
    };
  },
  watch: {
    selectAll() {
      if (this.selectAll) {
        this.listDeptSelected = this.departementsOptions
      } else {
        this.listDeptSelected = []
      }
    },
    selectDuree() {
      console.log(this.selectDuree);
      if (this.selectDuree) {
        this.date_fin_fr = moment().subtract(this.selectDuree.duree, this.selectDuree.type).format("DD-MM-YYYY");
      } else {
        this.date_fin_fr = moment().format("DD-MM-YYYY");
      }
    }
  },
  methods: {
    async exportDepartements() {
      try {
        console.log(this.listDeptSelected);
        if (this.listDeptSelected.length > 0) {
          let results = await axios.get("/api/exports/departements", {
            params: {
              listDept: this.listDeptSelected,
              include_adh_infos: this.include_adh_infos,
              max_date_exp: moment(this.date_fin_fr, "DD-MM-YYYY").format("YYYY-MM-DD")
            }
          });

          this.downloadItem(results.data, "export_departements.xlsx");
        } else {
          this.launchEpicmaxToast("Aucun département sélectionné");
          return;
        }
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l’export");
      }
    },
    async exportAcota() {
      try {
        let results = await axios.get("/api/exports/acota");

        this.downloadItem(results.data, "export_acota.xlsx");
      } catch (error) {
        console.log(error);
      }
    },
    async exportStructures() {
      try {
        let structures = [
          "",
          "scapp",
          "opam-b",
          "agromer",
          "languedoc",
          "vendee",
          "sdep"
        ];
        let structure = structures[this.structureSelected.id];

        let results = await axios.get("/api/exports/tierces", {
          params: { structure: structure }
        });

        this.downloadItem(results.data, "export.xlsx");
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l’export");
      }
    },
    async exportNonAdherents() {
      try {
        let results = await axios.get("/api/journal/extractNonAdherents");

        this.downloadItem(results.data, "export.xlsx");
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l’export");
      }

    },
    async exportAdherents(type) {
      try {
        if (type !== "all") {
          type = moment(this.startDateOpef, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        let results = await axios.get("/api/exports/adherents", {
          params: { type: type }
        });

        this.downloadItem(results.data, "export.xlsx");
      } catch (err) {
        console.log(err);
        this.launchEpicmaxToast("Erreur lors de l'export");
      }
    },
    async exportYearStatistics() {
      try {
        let results = await axios.get("/api/exports/yearStatistics", {
          params: { year: this.selectedYear },
          responseType: "blob"
        });

        const blob = new Blob([results.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `statistiques_${this.selectedYear}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l'export des statistiques");
      }
    },
    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then(response => {
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  }
};
</script>

<style></style>
